import { useEffect } from 'react';
import { Spinner } from 'react-bootstrap';
import { useHistory, useLocation, useParams } from 'react-router-dom';

const removeUpdatedFlag = (path) => {
    if (!path) return null;

    const [pathname, query = ''] = path.split('?');
    const params = new URLSearchParams(query);
    params.delete('updated');
    const nextQuery = params.toString();
    return nextQuery ? `${pathname}?${nextQuery}` : pathname;
};

const CreateVerificationFromCopy = () => {
    const { companyId } = useParams();
    const history = useHistory();
    const location = useLocation();
    const { verificationData, from, fiscalYear } = location.state || {};

    useEffect(() => {
        if (!verificationData) {
            history.replace(`/${companyId}/verifications`);
            return;
        }

        history.replace({
            pathname: `/${companyId}/manual-bookkeeping-entry`,
            state: {
                copyFrom: verificationData,
                fiscalYear,
                returnTo: removeUpdatedFlag(from) || `/${companyId}/verifications`,
            },
        });
    }, [companyId, fiscalYear, from, history, verificationData]);

    return (
        <div className="d-flex align-items-center justify-content-center py-5" role="status">
            <Spinner animation="border" size="sm" />
            <span className="ms-2">Öppnar kopian…</span>
        </div>
    );
};

export default CreateVerificationFromCopy;
